module.exports = __webpack_public_path__ + "static/bg1-c97ebcab3382db4d682be7ce77338bbd.jpg";